import dayjs from 'dayjs';
import { Grid, Box, Typography } from '@mui/material';
import { useTheme } from '@mui/private-theming';
import InfoModal from 'src/components/modal/InfoModal';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export default function DeadlineInfo() {
  const theme = useTheme();

  return (
    <Grid item>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          p: '1.5rem',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: 'red',
            fontWeight: 'bold',
            textAlign: 'center',
            mr: '0.125rem',
            whiteSpace: 'nowrap',
          }}
        >
          Filing Deadline is May 15, {dayjs().year()}
        </Typography>
        <InfoModal
          Icon={HelpOutlineIcon}
          sx={{
            color: theme.palette.primary.main,
            ml: '.5rem',
            cursor: 'pointer',
            fontSize: '2rem',
            padding: 0,
          }}
        >
          <Typography sx={{ my: '1rem' }}>
            Your Personal Property signed statement is due May 15, or 60 days from the statement
            date if mailed by the County after March 15. There will be no certified mail
            notification. An account that is not received by the due date is subject to estimation,
            penalties, and interest.
          </Typography>
          <Typography fontStyle="italic" sx={{ mb: '0.5rem' }}>
            If May 15th falls on a Saturday or Sunday the filing deadline will be adjusted to be the
            following Monday.
          </Typography>
        </InfoModal>
      </Box>
    </Grid>
  );
}
